// core
import { Injectable } from '@angular/core';

declare global {
  interface Window {
    _sva?: any;
  }
}

@Injectable()
export class RaptorSurvicateService {
  public invokeEvent(eventName: string, props: Object) {
    if (window._sva && typeof window._sva.invokeEvent === 'function') {
      window._sva.invokeEvent(eventName, props);
    }
  }
}
